const Marzipano = require("marzipano");
window.Marzipano = Marzipano;

import screenfull from "screenfull";
window.screenfull = screenfull;

import Bowser from "bowser";
window.bowser = Bowser;

import { DeviceOrientationControlMethod } from "./device-orientation";
window.DeviceOrientationControlMethod = DeviceOrientationControlMethod;
